import { defineMessages } from 'react-intl';

const messages = defineMessages({
  completed: {
    id: 'ProgressList.completed',
    defaultMessage: 'Completed!',
  },
  dontShowAgain: {
    id: 'markAsCompleteModal.dontShowAgain',
    defaultMessage: 'Don’t show this message again',
  },
  markAsComplete: {
    id: 'markAsCompleteModal.markAsComplete',
    defaultMessage: 'Mark as complete',
  },
  cancel: {
    id: 'markAsCompleteModal.cancel',
    defaultMessage: 'Cancel',
  },
  areYouSure: {
    id: 'markAsCompleteModal.areYouSure',
    defaultMessage: 'Are you sure?',
  },
  allLessonsWithin: {
    id: 'markAsCompleteModal.allLessonsWithin',
    defaultMessage: 'Everything in this course will also be marked complete.',
  },
  undo: {
    id: 'ProgressList.undo',
    defaultMessage: 'Undo',
  },
  viewCourseDetails: {
    id: 'ProgressList.viewCourseDetails',
    defaultMessage: 'View Course Details',
  },
  saveToFavorites: {
    id: 'ProgressList.saveToFavorites',
    defaultMessage: 'Save to Favorites',
  },
});

export default messages;
